import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
 
export interface ITipoPgto {
  idfolha: string;
  nome: string;
  urlimg: string;
  cpf: string;
  marcado: boolean;
  total: number;
}

async function ImprTipoPagamentoCheque(dados: ITipoPgto[], periodo: string, fazenda: string){
  
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const Total = dados.reduce((acc, item) => acc + item.total, 0);
  const Quantidade = dados.length;

  const rows = dados.map((row) => {
    return [
      {text: row.nome, alignment: 'left', fontSize: 10},
      {text: row.cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'), alignment: 'left', fontSize: 10},
      {},
      {},
      {},
      {text: '', border: [false, false, false, false],},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.total), alignment: 'right',  fontSize: 10},
    ]; 
  });  


  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous'; 
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl =  process.env.REACT_APP_URL_IMGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  
  const documentDefinition = {

    content: [
      {
        style: 'tableExample',
        table: {
          margin: [0, 0, 0, 0],
          widths: [48, 540],
          body: [
            [ 
              {
                image: imageData,     
                width: 48,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],
                table: {
                  body: [
                    [ 
                      {text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16,  margin: [0, 5, 0, 0], bold: true, color: '#FFFFFF',  alignment: 'center', fillColor: '#00A47B', border: [false, false, false, false]},
                    ],
                    [ 
                      {text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true]},
                    ],
                    [ 
                      {text: 'Relatório Tipo de Pagamento Cheque', margin: [5, 10, 0, 0], fontSize: 18, bold: true,  alignment: 'center',  border: [false, false, false, false]},
                    ],
                  ]
                }
              }
            ],
          ]
        }
      },
      {
        table:{
          margin: [5, 10, 5, 10],
          heights:[10],
          widths: [530],
          body: [
            [
              {text: 'Fazenda: '+fazenda+'\nPeríodo: '+periodo, border: [false, false, false, false]},
            ],
          ]
        },
      },
      {
        table:{
          widths: [ 200, 100, 10, 10, 10, 30, 70],
          body: [
            [
              {text: 'Colaborador', alignment: 'left', fontSize: 10},
              {text: 'CPF', alignment: 'left',   fontSize: 10},
              {text: '1', alignment: 'center',  fontSize: 10},
              {text: '2', alignment: 'center',  fontSize: 10},
              {text: '3', alignment: 'center',  fontSize: 10},
              {text: '', alignment: 'center', border: [false, false, false, false],  fontSize: 10},
              {text: 'Valor', alignment: 'right', fontSize: 10},
            ],
            ...rows,
            [
              {text: 'Quantidade de Colaboradores: '+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 0}).format(Quantidade), alignment: 'left',  fontSize: 10, bold: true, border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: 'Valor Total', alignment: 'right',  colSpan: 4, border: [false, false, false, false]},
              {},
              {},
              {},
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(Total), alignment: 'right',  fillColor: '#dddddd', fontSize: 10, bold: true},
            ]
          ]
          
        },
      },
      
    ]
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();

}
export default ImprTipoPagamentoCheque;

